import WebStorageCache from 'web-storage-cache'
// import CryptoJS from 'crypto-js'
var CryptoJS = require("crypto-js");

import JSEncrypt from 'jsencrypt';
import wx from "weixin-js-sdk";
import Cookie from 'js-cookie'


const _key = 'paycash202011201';

/**
 * 设置缓存
 * @param {*} key
 * @param {*} value
 */
export function setStorage(type, key, value, exp = Infinity) {
    const wsCache = new WebStorageCache({
        storage: `${type}Storage`,
    })
    wsCache.set(key, value, { exp })
}

/**
 * 获取缓存
 */
export function getStorage(type, key) {
    const wsCache = new WebStorageCache({
        storage: `${type}Storage`,
    })
    return wsCache.get(key)
}

/**
 * 清除缓存
 */
export function removeStorage(type, ...keys) {
    const wsCache = new WebStorageCache({
        storage: `${type}Storage`,
    })
    for (const key of Array.from(keys)) {
        wsCache.delete(key)
    }
}

export const getAppInfo = () => {
    let appVersion = '',
        appName = ''
    const system = navigator.userAgent.includes('iPhone') ? 'ios' : 'android'
    if (navigator.userAgent.indexOf('appVersion') !== -1) {
        const matchInfo =
            navigator.userAgent.match(/appVersion=(.+),appName=(.+)/) || []
        appVersion = matchInfo[1] || ''
        appName = matchInfo[2] || ''
    }
    return { appVersion, appName, system }
}

export const debounce = (fn, delay) => {
    let timer = null
    return function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
            fn.call(this, null)
        }, delay)
    }
}

// 生成uuid
export const createuuid = (len, radix) => {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
        ''
    )
    let uuid = []
    let i = 0
    let r = 0
    radix = radix || chars.length
    if (len) {
        for (i = 0; i < len; i++) {
            uuid[i] = chars[0 | (Math.random() * radix)]
        }
    } else {
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | (Math.random() * 16)
                uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
            }
        }
    }
    return uuid.join('')
}

export const getThemeByType = (type) => {
    const themeMap = {
        '0': 'default',
        '1': 'red',
        '2': 'rosiness',
        '3': 'black',
        '4': 'turquoise'
    }
    return themeMap[type]
}

export const isWeixin = () => {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
    } else {
        return false
    }
}

export const format = (date, fmt) => {
    var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    }
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
    for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            )
    return fmt
}

export const encrypt = (str) => {
    var encrypt = new JSEncrypt()
    encrypt.setPublicKey(
        'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCwSXheYRNahO3XMtne1Qgrd/Zk7n52w8aVVi/y3iuXpt4YMhhbnbI2dOvYhxSJp9skZ5fRS4fSYa8xZjm06eOlsk5if2ABw6O85y9NNLcjTBKkj6Ro7uGxvEK2/evav6pWgQyfU8dOLDlaH5VJxRskvizGFUpgtaTEi09PYOjKhwIDAQAB'
    )
    return encrypt.encrypt(str)
}

export const AesEncrypt = (str) => {
    if (Object.prototype.toString.call(str) === '[object Object]') {
        str = JSON.stringify(str);
    }
    let key = CryptoJS.enc.Utf8.parse(_key);
    let encryptedData = CryptoJS.AES.encrypt(str, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encryptedData.toString();
}

export const SHA256Encrypt = (str) => {
    if (Object.prototype.toString.call(str) === '[object Object]') {
        str = JSON.stringify(str);
    }
    return CryptoJS.SHA256(str).toString();
}

export const AesDecrypt = (str) => {
    let key = CryptoJS.enc.Utf8.parse(_key);
    let encryptedHexStr = CryptoJS.enc.Hex.parse(str);
    let encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);

    let decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    let decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);

    return decryptedStr;
}

export const md5Encrypt = (str) => {
    try {
        return CryptoJS.MD5(str).toString();
    } catch (e) {
        return "";
    }
}

export const BuildVersionDiff = (buildVersion) => {
    if (
        window.PPDWebUI &&
        window.PPDWebUI.os.inApp &&
        window.PPDWebUI.os.channel === 'PPDLoanApp'
    ) {
        const x = PPDWebUI.os.buildVersion.match(/(\d+)\.(\d+)\.(\d+)/);
        const y = buildVersion.match(/(\d+)\.(\d+)\.(\d+)/);

        let result = parseInt(x[1] + x[2].padStart(2, '0') + x[3].padStart(2, '0')) >= parseInt(y[1] + y[2].padStart(2, '0') + y[3].padStart(2, '0'));
        return result;
    }
}

export const getLastLen = (str, len = 4) => {
    if (!str) return '';
    return str.substring(str.length - len)
}

export const getBizType = () => {
    if (location.origin.includes("koofenqi.com")) {
        return "Koo";
    }
    if (location.origin.includes("paifenle.com")) {
        return "Tars";
    }
    if (location.origin.includes("ppdai.com")) {
        return "Loan";
    }
    return "Loan";
}

export const diffVersion = (version, newVersion) => {
    const x = version.match(/(\d+)\.(\d+)\.(\d+)/);
    const y = newVersion.match(/(\d+)\.(\d+)\.(\d+)/);

    let result = parseInt(x[1] + x[2].padStart(2, '0') + x[3].padStart(2, '0')) >= parseInt(y[1] + y[2].padStart(2, '0') + y[3].padStart(2, '0'));
    return result;
}

// 通过ua比较版本
export const lasterVersion = function (reqV) {
    try {
        let ua = navigator.userAgent.toLowerCase();
        let curV = ua.match(/ppdkoouapp\/([^\s]*)/);
        if (!curV || curV.length < 2) return false;
        let arr1 = curV[1].toString().split('.');
        let arr2 = reqV.toString().split('.');
        // 将两个版本号拆成数
        let minL = Math.min(arr1.length, arr2.length);
        let pos = 0; // 当前比较位
        let diff = 0; // 当前为位比较是否相等
        let flag = true;
        // 逐个比较如果当前位相等则继续比较下一位
        while (pos < minL) {
            diff = parseInt(arr1[pos], 10) - parseInt(arr2[pos], 10);
            if (diff === 0) {
                pos++;
                continue;
            } else if (diff > 0) {
                flag = true;
                break;
            } else {
                flag = false;
                break;
            }
        }
        return flag;
    } catch (e) {
        return false;
    }
};

export const getCommonEnv = () => {
    const UA = navigator.userAgent.toLowerCase();
    const isKoouApp = UA.indexOf('koousdk_platform') > -1 || UA.indexOf('ppdwebui') > -1; // flutter ios and native android
    return {
        isAndroid: UA.indexOf('android') > 0,
        isIos: /iphone|ipad|ipod|ios/.test(UA),
        isWechat: // 企业微信 or 个人微信
            UA.indexOf('micromessenger') > 0 &&
            window.__wxjs_environment !== 'miniprogram' &&
            UA.indexOf('miniprogram') < 0,
        isWechatApp: window.__wxjs_environment === 'miniprogram' || UA.indexOf('miniprogram') > 0,
        isKooApp: UA.indexOf('ppdwebui') > -1, // native android
        // isKooAppIos: /iphone|ipad|ipod|ios/.test(UA) && UA.indexOf('ppdwebui') > -1,
        isKooAppAndroid: UA.indexOf('android') > 0 && UA.indexOf('ppdwebui') > -1, // native android
        isZhuanzhuan: window.location.pathname.indexOf('zhuanzhuan') > -1,
        isKidswantAndroid: UA.indexOf('koosdk_platform/android') > -1,
        isKidswantIos: UA.indexOf('koosdk_platform/ios') > -1,
        isKoouApp,
        isKoouAppIos: /iphone|ipad|ipod|ios/.test(UA) && UA.indexOf('koousdk_platform') > -1, // flutter ios
        isKoouAppAndroid: UA.indexOf('android') > 0 && UA.indexOf('koousdk_platform') > -1, // flutter android
        isWechatPerson: UA.indexOf('micromessenger') > 0 &&
            window.__wxjs_environment !== 'miniprogram' &&
            UA.indexOf('miniprogram') < 0 && UA.indexOf('wxwork') < 0, // 个人微信
        isWechatWork: UA.indexOf('micromessenger') > 0 && UA.indexOf('wxwork') > 0, // 企业微信
        isOppoKoouApp: isKoouApp && UA.indexOf('koofenqi_oppo') > -1 // oppo渠道包
    };
}

// export const isWxMiniProgram = () => {
//     let flag = false;
//     try {
//         return isWeixin() && Boolean(getCookie("miniappChannel"));
//         // if (isWeixin()) {
//         //     if (wx && wx.miniProgram) {
//         //         wx.miniProgram.getEnv((res) => {
//         //             if (res.miniprogram) {
//         //                 flag = true;
//         //             }
//         //         })
//         //     }
//         // }
//         // return flag;
//     } catch (e) {
//         return flag;
//     }
// }

export const isWxMiniProgram = () => {
    let flag = false;
    try {
        return isWeixin() && Boolean(getCookie("miniappChannel")) && (window.__wxjs_environment === 'miniprogram' || /miniProgram/.test(navigator.userAgent));
    } catch (e) {
        return flag;
    }
}

export const getCookie = (cookieName) => {
    try {
        if (!cookieName) return '';
        return Cookie.get(cookieName);
    } catch (e) {
        return '';
    }
}

export const setCookie = (name, value, options = {}) => {
    try {
        Cookie.set(name, value, options);
    } catch (e) {
        console.log(e)
    }
}

export const cleanArray = (actual) => {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

export const queryFormat = (json) => {
    if (!json) return '';
    return cleanArray(Object.keys(json).map(key => {
        if (json[key] === undefined) return '';
        return key + '=' + encodeURIComponent(json[key])
    })).join('&')
}

// h5跳转小程序页面
export const navigateTo = (url, params) => {
    uni && uni.navigateTo({ url: url + '?' + queryFormat(params) })
}

export const getIp = () => {
    return new Promise((resolve, reject) => {
        var script = document.createElement('script')
        script.src = 'https://pv.sohu.com/cityjson?ie=utf-8'
        script.onload = function () {
            resolve(window.returnCitySN)
        }
        document.body.appendChild(script)
    })
}

// export const isMiniProgram = () => {
//     let flag = false;
//     try {
//         return isWxMiniProgram() && (window.__wxjs_environment === 'miniprogram' || /miniProgram/.test(navigator.userAgent));
//     } catch (e) {
//         return flag;
//     }
// }

export const isTTWebView = () => {
    try {
        const UA = navigator.userAgent.toLowerCase();
        return UA.includes("toutiaomicroapp");
    } catch (e) {
        console.log(e)
        return false;
    }
}

export const getEnv = () => {
    try {
        const bizType = getBizType();

        if (bizType == 'Loan') {
            if (isTTWebView()) {
                return 'TTMiniprogram';
            } else if (isWxMiniProgram()) {
                return 'LoanMiniprogram';
            } else if (isWeixin()) {
                return 'LoanWx';
            }
        } else if (bizType == 'Koo') {
            if (isWeixin() && (window.__wxjs_environment === 'miniprogram' || /miniProgram/.test(navigator.userAgent))) {
                return 'KooMiniprogram';
            } else if (isWeixin()) {
                return 'KooWx';
            }
        }
        return bizType;
    } catch (e) {
        return 'Loan';
    }
}

export const getFormData = (data) => {
    try {
        const _data = typeof data == 'string' ? JSON.parse(data) : data;
        const params = [];
        for (let item of Object.keys(_data)) {
            params.push({ name: item, value: _data[item] });
        }
        return params;
    } catch (e) {
        console.log(e);
        return [];
    }
}


// 原生Title公共设置方法
export const setNavigation = (params) => {
    try {
        if (params.titleView && params.titleView.title) {
            document.title = params.titleView.title;
        }
        // 借款app或理财app
        if (
            window.PPDWebUI &&
            window.PPDWebUI.os.inApp &&
            ["PPDLendApp", "PPDLoanApp"].includes(
                window.PPDWebUI.os.channel
            )
        ) {
            window.PPDWebUI.CommonService.setNavigation(
                Object.assign({}, params),
                function () { },
                function (err) { }
            );
        }
    } catch (e) {
        console.log(e)
    }
}

export const addWhiteList = () => {
    try {
        if (
            window.PPDWebUI &&
            window.PPDWebUI.os.inApp &&
            ["PPDLoanApp"].includes(
                window.PPDWebUI.os.channel
            )
        ) {
            window.PPDWebUI.TempWhiteListService.addWhiteList({ rules: ['https://*.cmbchina.com/*', 'cmbmobilebank://*'] });
        }
    } catch (e) {
        console.log(e)
    }
}

export const inLoanApp = () => {
    try {
        return window.PPDWebUI && window.PPDWebUI.os.inApp && ["PPDLoanApp"].includes(window.PPDWebUI.os.channel);
    } catch (e) {
        return false;
    }
}

export const inKooApp = () => {
    try {
        return window.XYPayAndroid ||
            (window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.XYPay);
    } catch (e) {
        return false;
    }
}

export const addWhiteListNative = (rulesArray, callBack) => {
    try {
        if (
            window.PPDWebUI &&
            window.PPDWebUI.os.inApp &&
            ["PPDLoanApp"].includes(
                window.PPDWebUI.os.channel
            )
        ) {
            window.PPDWebUI.TempWhiteListService.addWhiteList({ rules: rulesArray }, res => {
                callBack && callBack(res);
            });
        }
    } catch (e) {
        console.log(e)
    }
}

export const bankCardRegularCheck = (num) => {
    if (num) {
        const trimed = num.replace(/\s/g, "");
        const reg = /^(\d|\*)+$/g;

        return reg.test(trimed);
    }
    return false;
}

export const isAndroid = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('android') > 0;
}

// export const isIos = () => {
//     const ua = window.navigator.userAgent.toLowerCase()
//     return /iphone|ipad|ipod|ios/.test(ua);
// }